import { AUTH_URL, REDIRECT_URL, TOKEN_URL } from '../../../constants/env';
import OAuth2Client from './OAuth2Client';
import { getClientId } from './utils';

function oAuth2Client(testMode: boolean = false) {
  return new OAuth2Client({
    audience: 'laterpay',
    authorizationServerUri: AUTH_URL ?? '',
    clientId: getClientId(testMode),
    providerId: 'tapper-sso',
    redirectUri: REDIRECT_URL ?? '',
    scope: 'tab:tab:read tab:purchase:read auth:user:read business:card:read business:merchant:read offline_access',
    tokenServerUri: TOKEN_URL ?? '',
    testMode: testMode,
  });
}

export { oAuth2Client };
